import _ from 'lodash';
import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import Button from 'shared/components/Button';
import HorizontalBox from 'shared/components/HorizontalBox';
import SkipStep from 'shared/components/SkipStep';
import ExternalLink from 'shared/components/ExternalLink';
import { nextStep, patchUserLifecycle } from 'shared/components/Signup/ducks';
import { substituteUrl } from 'shared/utils/substituteUrl';
import { RESOURCE_DETAIL_URL } from 'global-constants';

import { getImage } from './utils';
import styles from './styles.module.scss';

class ChooseLifecycle extends Component {
  state = {
    chosenLifecycles: []
  };

  toggleLifecycle = lifecycle => {
    const newChoosenLifecycles = _.xor(this.state.chosenLifecycles, [
      lifecycle.value
    ]);
    this.setState({ chosenLifecycles: newChoosenLifecycles });
  };

  isLifecycleSelected = lifecycle => {
    return _.indexOf(this.state.chosenLifecycles, lifecycle.value) > -1;
  };

  render() {
    const { lifecycles, nextStep } = this.props;

    const { chosenLifecycles } = this.state;

    return (
      <div className={styles.lifecyclesWrapper}>
        <div className={classnames('secondary-page-title', styles.pageTitle)}>
          What part of the Asset Lifecycle do you specialise in?
        </div>
        <div className="page-title-label">
          Add as many as you like. Not sure what lifecycle?{' '}
          <ExternalLink
            className={styles.learnMoreLink}
            href={substituteUrl(RESOURCE_DETAIL_URL, {
              resourceSlug: 'proptech-asset-lifecycle'
            })}>
            Learn more here.
          </ExternalLink>
        </div>
        <div className={styles.lifecyclesRow}>
          {lifecycles.map(lifecycle => {
            let imageSrc = getImage(lifecycle.label.split('/')[0]);
            return (
              <HorizontalBox
                key={lifecycle.label}
                image={imageSrc}
                title={lifecycle.label}
                onClickEvent={() => this.toggleLifecycle(lifecycle)}
                selected={this.isLifecycleSelected(lifecycle)}
              />
            );
          })}
        </div>
        <div className={styles.nextStepAndSkipStepWrapper}>
          <Button
            className={styles.nextStepBtn}
            color="primary"
            onClick={() =>
              this.props.patchUserLifecycle({ lifecycle: chosenLifecycles })
            }
            disabled={_.isEmpty(chosenLifecycles)}>
            Next Step: Your Location
          </Button>
          <SkipStep onClickEvent={nextStep} className={styles.skipStepLink} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const lifecycles =
    state.constants.constants.vendors.PROPERTY_LIFECYCLE_STAGE_CHOICES;

  return {
    lifecycles
  };
};

const mapDispatchToProps = {
  patchUserLifecycle,
  nextStep
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChooseLifecycle);
